import React from 'react';
import moment from "moment";
import { FORMAT } from '../common/constant';
import PropTypes from "prop-types";

const UDateFormatter = (props) => {
    return (props.date ? moment(props.date).format(props.format) : '-');
};
UDateFormatter.propTypes = {
    date: PropTypes.any,
    format: PropTypes.string,

};
UDateFormatter.defaultProps = {
    date: null,
    format: FORMAT.DAY_DATE_MONTH,
};

export default UDateFormatter;
